module.exports = __webpack_public_path__ + "img/aeroland-client-logo-08.a602406f.png";